const desktop = 900;
const mobile = 600;

export class ScreenSizes {
  desktop = desktop;
  tablet: number;
  mobile = mobile;

  public static screenSize(wholeWidth = false) {
    if (typeof window === 'undefined') return 'desktop';
    const size = wholeWidth ? window.innerWidth : document.documentElement.clientWidth;

    if (size < mobile) return 'mobile';
    if (size < desktop) return 'tablet';
    return 'desktop';
  }

  public static windowWidth() {
    if (typeof window === 'undefined') return 0;
    return window.innerWidth;
  }
}
